import { Mail, MapPin, Phone } from "lucide-react";
import { CONTACT } from "@/lib/data";
import { Reveal } from "@/components/site/Reveal";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer id="contato" data-testid="site-footer" className="grain relative bg-[#0f2419] text-[#faf7f2]">
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 py-20 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <img src="/img/logo-white.png" alt="Reserva Mantiqueira" className="h-28 w-28 object-contain" />
            <p className="mt-8 text-3xl font-bold uppercase leading-tight tracking-tight sm:text-4xl">
              Até breve,<br /><span className="text-[#e9c9a8]">na serra.</span>
            </p>
          </Reveal>
          <Reveal delay={0.1} className="space-y-6 lg:col-span-3">
            <a data-testid="footer-whatsapp" href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="flex gap-3 text-sm hover:text-[#e9c9a8]">
              <Phone className="h-4 w-4 flex-none text-[#c86d4b]" /> {CONTACT.phone}
            </a>
            <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="flex gap-3 break-all text-sm hover:text-[#e9c9a8]">
              <Mail className="h-4 w-4 flex-none text-[#c86d4b]" /> {CONTACT.email}
            </a>
            <p data-testid="footer-address" className="flex gap-3 text-sm leading-relaxed text-[#d9d4c9]">
              <MapPin className="h-4 w-4 flex-none text-[#c86d4b]" /> {CONTACT.address}
            </p>
          </Reveal>
          <Reveal delay={0.2} className="lg:col-span-4">
            <div className="aspect-[4/3] overflow-hidden rounded-sm">
              <iframe
                title="Mapa Reserva Mantiqueira"
                data-testid="footer-map"
                src="https://www.google.com/maps?q=Tabarana+de+Baixo,+Serra+Negra+-+SP,+13938-899&output=embed"
                className="h-full w-full border-0 grayscale-[40%]"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
        <div className="mt-16 flex flex-col gap-2 border-t border-[#2c4a38] pt-6 text-xs text-[#b8c4bb] sm:flex-row sm:justify-between">
          <p>© {year} Reserva Mantiqueira · CNPJ {CONTACT.cnpj}</p>
          <p>Serra Negra · SP</p>
        </div>
      </div>
    </footer>
  );
}
